import setCompareItems from './setCompareItems.js';

/**
 * Reset compare tool
 */
export default async () => setCompareItems({ items: [] });
